module.exports = __webpack_public_path__ + "static/design-leggings.810b67e2.svg";